// import React from 'react';
// import "./RightSection.css";

// const RightSection = () => {
//   return (
//     <div className={`card p-4 ${"rightSection"}`}>
//       <h3 className="text-danger">Why This Matters?</h3>
//       <ul className="list-group">
//         <li className="list-group-item">Active listening helps you fully understand customer concerns, reducing errors and frustration.</li>
//         <li className="list-group-item">Clear communication builds rapport and increases customer satisfaction.</li>
//         <li className="list-group-item">Strong listening skills can improve call resolution time and boost overall performance.</li>
//       </ul>
//       <h3 className="mt-4 text-info">Additional Tips</h3>
//       <ul className="list-group">
//         <li className="list-group-item"><strong>Stay Present 
//             </strong> Avoid thinking about your response while the customer is speaking .Focus entirely on their words.</li>
//         <li className="list-group-item"><strong>Use Positive Body Language:</strong> Open posture, maintain eye contact.</li>
//         <li className="list-group-item"><strong>Be Patient:</strong> Allow customers to fully express themselves.</li>
//       </ul>
//     </div>
//   );
// };


// export default RightSection;
import React from 'react';
import "./RightSection.css";
import check_circle from '../../../assets/images/check_circle.png'; // Corrected import
import AdditionalTips from '../../../assets/images/AdditionalTips.png';
import { useLocation } from "react-router-dom";

const RightSection = () => {

  const location = useLocation();
  const resource = location.state?.resource; // Get passed resource data
  // console.log(resource);

  const developmentPlan = resource?.whyThisMatters || []; // Ensure it's an array
  // console.log(developmentPlan);

  const tipsList = resource?.additionalTips || []; // Ensure it's an array
  // console.log(tipsList);

 // Hardcoded titles for tips (this is the static part)
 const hardcodedTitles = [
  "Stay Present",
  "Use Positive Body Language",
  "Be Patient"
];
  return (
    <div className="rightSection-container">
      <div className="rightSection-section">
        <h2>Why This Matters?</h2>
        <ul>
          {developmentPlan.map((item, index) => (
            <li key={index}>
              <img src={check_circle} alt="Check Circle" className="rightSection-list-image" />
              {item} {/* Dynamically binding each array item */}
            </li>
          ))}
        </ul>
      </div>

      

      <div class="rightSection-tips">
        <div class="rightSection-rightsection-icon">
          <img src={AdditionalTips} alt="Tips" className='rightSection-addtionalTips' />
          <h2>Additional Tips</h2>
        </div>
        {/* Render hardcoded titles with dynamic content from tipsList */}
        {tipsList.map((tip, index) => (
          <div key={index}>
            <strong className="rightSection-strong">{hardcodedTitles[index]}</strong><br />
            <p>{tip}</p> {/* Dynamically bind the content from the backend */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RightSection;
